/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ChangeEmployerRequest,
    ChangeEmployerRequestFromJSON,
    ChangeEmployerRequestToJSON,
} from '../models/ChangeEmployerRequest';
import {
    type EmployerDependentAccessesResponse,
    EmployerDependentAccessesResponseFromJSON,
    EmployerDependentAccessesResponseToJSON,
} from '../models/EmployerDependentAccessesResponse';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/ProblemDetails';

export interface ApiExternalUserEmployerPostRequest {
    changeEmployerRequest: ChangeEmployerRequest;
}

/**
 * 
 */
export class ExternalUserEmployerApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiExternalUserEmployerGet without sending the request
     */
    async apiExternalUserEmployerGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/external-user-employer`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiExternalUserEmployerGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmployerDependentAccessesResponse>> {
        const requestOptions = await this.apiExternalUserEmployerGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmployerDependentAccessesResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiExternalUserEmployerGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmployerDependentAccessesResponse> {
        const response = await this.apiExternalUserEmployerGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiExternalUserEmployerPost without sending the request
     */
    async apiExternalUserEmployerPostRequestOpts(requestParameters: ApiExternalUserEmployerPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['changeEmployerRequest'] == null) {
            throw new runtime.RequiredError(
                'changeEmployerRequest',
                'Required parameter "changeEmployerRequest" was null or undefined when calling apiExternalUserEmployerPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/external-user-employer`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeEmployerRequestToJSON(requestParameters['changeEmployerRequest']),
        };
    }

    /**
     */
    async apiExternalUserEmployerPostRaw(requestParameters: ApiExternalUserEmployerPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiExternalUserEmployerPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiExternalUserEmployerPost(requestParameters: ApiExternalUserEmployerPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiExternalUserEmployerPostRaw(requestParameters, initOverrides);
    }

}
